import type { Distance, Rectangle } from "@pdfking/math"
import { POS_INFINITY } from "@pdfking/math"
import type { PrimaryKey } from "@pdfking/templates"
import { RecordByPrimaryKey } from "@pdfking/templates"

export type MaterialEntry = PrimaryKey<string> & {
  name: string
} & Rectangle<Distance>

// "No material": an unbounded sheet, the default choice. Selecting it means the
// component isn't cut from a stock sheet, so it never reports cut waste.
export const NO_MATERIAL: MaterialEntry = {
  id: "no",
  name: "—",
  width: POS_INFINITY as Distance,
  height: POS_INFINITY as Distance,
}

export const BuildMaterialChoices = (list?: MaterialEntry[]) =>
  RecordByPrimaryKey([NO_MATERIAL, ...(list ?? [])] as MaterialEntry[])
